import React from 'react';
import Icon from '../../../components/AppIcon';

const FilterModal = ({ isOpen, onClose, filters, onFilterChange }) => {
  if (!isOpen) return null;

  const handleBackdropClick = (e) => {
    if (e?.target === e?.currentTarget) {
      onClose();
    }
  };

  return (
    <div 
      className="fixed inset-0 bg-black/50 z-[100] flex items-end sm:items-center sm:justify-center"
      onClick={handleBackdropClick}
    >
      <div className="bg-card w-full sm:max-w-md sm:rounded-lg rounded-t-2xl border-t sm:border border-border max-h-[85vh] overflow-hidden flex flex-col animate-slide-up">
        {/* Header */}
        <div className="flex items-center justify-between p-16 border-b border-border">
          <h3 className="text-lg font-semibold text-foreground">Filters</h3>
          <button
            onClick={onClose}
            className="p-8 hover:bg-muted rounded-lg transition-colors"
          >
            <Icon name="X" size={20} color="var(--color-foreground)" />
          </button>
        </div>

        {/* Content */}
        <div className="flex-1 overflow-y-auto p-16 space-y-20">
          {/* Search */}
          <div>
            <label className="block text-sm font-medium text-foreground mb-8">
              Search
            </label>
            <div className="relative">
              <Icon 
                name="Search" 
                size={16} 
                color="var(--color-muted-foreground)" 
                className="absolute left-12 top-1/2 transform -translate-y-1/2"
              />
              <input
                type="text"
                value={filters?.searchQuery || ''}
                onChange={(e) => onFilterChange('searchQuery', e?.target?.value)}
                placeholder="Search bills..."
                className="w-full pl-36 pr-12 py-10 bg-background border border-border rounded-lg text-sm text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-primary/50"
              />
            </div>
          </div>

          {/* Status Filter */}
          <div>
            <label className="block text-sm font-medium text-foreground mb-8">
              Status
            </label>
            <div className="grid grid-cols-3 gap-8">
              {[
                { value: 'all', label: 'All' },
                { value: 'active', label: 'Active' },
                { value: 'paused', label: 'Paused' }
              ]?.map(option => (
                <button
                  key={option?.value}
                  onClick={() => onFilterChange('filterStatus', option?.value)}
                  className={`px-12 py-8 rounded-lg text-sm font-medium transition-colors ${
                    filters?.filterStatus === option?.value
                      ? 'bg-primary text-primary-foreground'
                      : 'bg-background border border-border text-foreground hover:bg-muted'
                  }`}
                >
                  {option?.label}
                </button>
              ))}
            </div>
          </div>

          {/* Frequency Filter */}
          <div>
            <label className="block text-sm font-medium text-foreground mb-8">
              Frequency
            </label>
            <div className="grid grid-cols-2 gap-8">
              {[
                { value: 'all', label: 'All' },
                { value: 'weekly', label: 'Weekly' },
                { value: 'monthly', label: 'Monthly' },
                { value: 'yearly', label: 'Yearly' }
              ]?.map(option => (
                <button
                  key={option?.value}
                  onClick={() => onFilterChange('filterFrequency', option?.value)}
                  className={`px-12 py-8 rounded-lg text-sm font-medium transition-colors ${
                    filters?.filterFrequency === option?.value
                      ? 'bg-primary text-primary-foreground'
                      : 'bg-background border border-border text-foreground hover:bg-muted'
                  }`}
                >
                  {option?.label}
                </button>
              ))}
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="p-16 border-t border-border flex gap-12">
          <button
            onClick={() => {
              onFilterChange('filterStatus', 'all');
              onFilterChange('filterFrequency', 'all');
              onFilterChange('searchQuery', '');
            }}
            className="flex-1 px-16 py-10 bg-background border border-border text-foreground rounded-lg text-sm font-medium hover:bg-muted transition-colors"
          >
            Reset
          </button>
          <button
            onClick={onClose}
            className="flex-1 px-16 py-10 bg-primary text-primary-foreground rounded-lg text-sm font-medium hover:bg-primary/90 transition-colors"
          >
            Apply
          </button>
        </div>
      </div>
    </div>
  );
};

export default FilterModal;